/*
 * Encart « produit offert dès X € » des fiches produit.
 *
 * Le Liquid ne rend jamais l'état du panier : les pages produit passent par le
 * cache de Shopify, et un montant rendu côté serveur pourrait être celui d'un
 * autre visiteur. On part donc du texte « panier vide » et on le remplace ici,
 * après lecture de /cart.js.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-pm-gift-threshold]';
  var CART_ROUTES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function nodes() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      try {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      } catch (e) {
        /* on retombe sur Intl juste en dessous */
      }
    }
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function echappe(txt) {
    return String(txt)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // ** ** -> <strong>, comme dans le snippet Liquid. Tout est échappé d'abord,
  // seules les balises <strong> que l'on ajoute ici sont du HTML.
  function gras(txt) {
    return String(txt)
      .split('**')
      .map(function (part, i) {
        var e = echappe(part);
        return i % 2 === 1 ? '<strong>' + e + '</strong>' : e;
      })
      .join('');
  }

  function apply(el, total, currency) {
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    var target = el.querySelector('[data-pm-gift-text]');
    if (!target || !threshold || isNaN(total)) return;

    var text;
    if (total <= 0) {
      text = el.getAttribute('data-tpl-default');
    } else if (total >= threshold) {
      text = el.getAttribute('data-tpl-unlocked');
    } else {
      text = (el.getAttribute('data-tpl-remaining') || '').replace(
        '{amount}',
        formatMoney(threshold - total, currency)
      );
    }

    if (text) {
      var html = gras(text);
      if (target.innerHTML !== html) target.innerHTML = html;
    }
    el.removeAttribute('data-pm-gift-pending');
    el.setAttribute('data-pm-gift-state', total >= threshold ? 'unlocked' : 'pending-threshold');
  }

  var inFlight = null;

  function refresh() {
    var els = nodes();
    if (!els.length) return;
    if (inFlight) return inFlight;

    els.forEach(function (el) {
      el.setAttribute('data-pm-gift-pending', '');
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    inFlight = fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) throw new Error('cart indisponible');
        els.forEach(function (el) {
          apply(el, cart.total_price, cart.currency);
        });
      })
      .catch(function () {
        // Panier illisible : on laisse le texte par défaut, qui reste exact.
        els.forEach(function (el) {
          el.removeAttribute('data-pm-gift-pending');
        });
      })
      .then(function () {
        inFlight = null;
      });

    return inFlight;
  }

  // Le thème n'a pas de bus d'événements panier unifié : on observe les appels
  // aux routes de panier en laissant passer la requête telle quelle.
  if (window.fetch && !window.__pmGiftFetchHooked) {
    window.__pmGiftFetchHooked = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      // `this || window` : appelé nu, `this` vaut undefined en mode strict, et
      // certains moteurs refusent alors l'invocation d'une API native.
      var result = nativeFetch.apply(this || window, arguments);
      if (CART_ROUTES.test(url)) {
        result.then(
          function () {
            setTimeout(refresh, 0);
          },
          function () {}
        );
      }
      return result;
    };
  }

  ['cart:refresh', 'quantity:update'].forEach(function (name) {
    document.addEventListener(name, refresh);
    window.addEventListener(name, refresh);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
